import { create } from "zustand";

/**
 * Holds the CSRF token in memory only (never localStorage / sessionStorage).
 *
 * Flow:
 *  - Backend issues a non-HttpOnly cookie `csrf_token` on /auth/login and /auth/refresh.
 *  - The login response body also includes `csrf_token`, which we save here.
 *  - apiClient reads it via `csrfStore.getState().token` and adds the header
 *    `X-CSRF-Token` to every state-changing request.
 *  - On logout we clear it.
 */
interface CSRFState {
	token: string | null;
	setToken: (t: string | null) => void;
	clear: () => void;
}

export const useCSRFStore = create<CSRFState>((set) => ({
	token: null,
	setToken: (t) => set({ token: t }),
	clear: () => set({ token: null }),
}));

// Helper for non-React modules (apiClient) — reads from the same store.
export function getCSRFToken(): string | null {
	return useCSRFStore.getState().token;
}

export function setCSRFToken(token: string | null): void {
	useCSRFStore.getState().setToken(token);
}
